module.exports = __webpack_public_path__ + "img/logo.6448b3b7.png";